import { Dispatch, SetStateAction } from 'react'
import TableTopper from '../../../../../global/components/table/helpers/table-topper/TableTopper'
import TableTitle from '../../../../../global/components/table/helpers/table-title/TableTitle'
import Table from '../../../../../global/components/table/Table'
import { Column } from 'react-table'
import styles from './styles.module.css'
import PrimaryCheckbox from '../../../../../global/components/checkbox/Checkbox'
import {
  IWeekCalendar,
  IWeekCalendarPartial,
} from '../../../../../../../app/entities/WeekCalendar'
import { DAYS_OF_WEEK } from '../../../../../global/constants/date'

interface IWorkingDaysTableProps {
  weekCalendars: IWeekCalendarPartial[]
  setWeekCalendars: Dispatch<SetStateAction<IWeekCalendarPartial[]>>
}

export default function WorkingDaysTable({
  weekCalendars,
  setWeekCalendars,
}: IWorkingDaysTableProps) {
  function handleWeekCalendarChange(
    newValue: boolean,
    weekDay: string,
    rowIndex: number,
  ) {
    const newWeekCalendars = weekCalendars.map((weekCalendar, index) =>
      index === rowIndex
        ? { ...weekCalendar, [weekDay]: newValue }
        : weekCalendar,
    )
    setWeekCalendars(newWeekCalendars)
  }

  const columns: Column<IWeekCalendar>[] = [
    {
      Header: 'Week',
      accessor: 'weekName',
    },
    ...DAYS_OF_WEEK.map((day) => ({
      Header: day.substring(0, 3),
      accessor: (data: any, rowIndex: number) => {
        const { [day.toLowerCase()]: dayValue } = data
        return (
          <PrimaryCheckbox
            checked={dayValue}
            name={day.toLowerCase()}
            onChange={(e) =>
              handleWeekCalendarChange(
                e.target.checked,
                e.target.name,
                rowIndex,
              )
            }
          />
        )
      },
    })),
  ]

  return (
    <div style={{ width: '100%' }}>
      <TableTopper>
        <div className={styles.titleButtonContainer}>
          <TableTitle>Working Days</TableTitle>
        </div>
      </TableTopper>
      <Table
        columns={columns}
        data={weekCalendars as any}
        isDisplayMode={true}
        isLoading={false}
      />
    </div>
  )
}
